import React from 'react';
import { Heading } from '../common/heading';
import Upcoming from '../common/upcoming';

const ReactQuery = () => {
	return (
		<div>
			<Heading
				text="React Query"
				description="In this section, React Query usages will be utilized."
			/>
			<Upcoming />
		</div>
	);
};

export default ReactQuery;
